import * as React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Pagination from '@mui/material/Pagination';
import EditComp from '../util/EditComp';
import EditarPaginaYoutube from '../page/editar/EditarPaginaYoutube';
import Service from '../../util/Service';
import { Avatar, CardHeader, IconButton, Stack } from '@mui/material';
import YoutubeDialog from './YoutubeDialog';

function VideoCard({video, doAction}) {
    const handleAssistir=()=>{
        console.log( video );
        if(doAction)doAction(video);
    }
    return (
      <Card sx={{ minWidth: 275 }}>
        <CardHeader
        avatar={
          <Avatar 
            sx={{ bgcolor: red[500] }} aria-label="recipe"
            src={'http://localhost:8080/api/getAnexoById/'+video.avatar}
            />
         
        }
        title={video.palestrante}
        subheader={"Livro: "+video.fonte}
      />
        <CardContent>
          <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
            {video.tipo}
          </Typography>
          <Typography variant="h4" component="div" sx={{textAlign:'center'}}>
            {video.nome}
          </Typography>
          <Box sx={{
            border: 'solid rgba(211, 220, 50, 0.6) ;',
            borderRadius: "30px"
          }}>
            <Typography variant="body2" sx={{m:1, textAlign:'center'}}>            
                {video.local}
            </Typography>
          </Box>
        </CardContent>
        <CardActions sx={{ 
            // background:'green',
            alignSelf: "stretch",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // 👇 Edit padding to further adjust position
            p: 1,
            }}  >
                <Button variant="outlined"  onClick={handleAssistir}
                    endIcon={<YouTubeIcon />}
                >Assistir</Button>
        </CardActions>
      </Card>
    );
  }

export default function YoutTubeComp(props) {
    const { tipo, edit } = props;
    const [page, setPage] = React.useState(1);
    const [open, setOpen] = React.useState(false);
    const [palestras, setPalestras] = React.useState();
    const [abrir, setAbrir] = React.useState(false);
    const [video, setVideo] = React.useState();

    React.useEffect(()=>{
        const paginacao = {
            page: page,
            count:10
        }
        Service.POST("/api/youtube/galeria", paginacao).then(r=>{
            console.log( r );
            setPalestras(r)
        }).catch( e =>{
            console.error( e );
        })
    },[]);

    const handleChange = (event, value) => {
        setPage(value);
    };
    const handleEditarPagina=()=>{
        console.log('>handleEditarPagina<');
        setOpen(true)
    }
    const handleYoutubeSalvo=()=>{
        console.log('>handleYoutubeSalvo<');
    }
    function getColunas(){
        const UserAgent = navigator.userAgent        
        if( window.screen.width > 900) return 4;
        if( window.screen.width > 600) return 6;
        return 12;
    }
    const verVideo=(vd)=>{
        console.log(".......");
        setAbrir( true );
        setVideo(vd);
    }

    return (
        <Grid container spacing={1}>
            { edit === true && <Grid size={12}> 
                <EditComp tip="Editar Pagina" action={handleEditarPagina} edit={edit} float={true}/> 
            </Grid>}
            {palestras && palestras.map((item)=>(
                <Grid size={getColunas()} key ={item.id}>
                    <VideoCard video={item} doAction={verVideo}/>
                </Grid>
            ))}
            
            <Grid size={12}>
                <Pagination count={100} page={page} onChange={handleChange} 
                    style={{margin:'auto', width: '50%', padding:'10px'}}
                />
            </Grid>
            <EditarPaginaYoutube open={open} setOpen={setOpen} doAction={handleYoutubeSalvo} tipo={tipo}/>
            <YoutubeDialog open={abrir} setOpen={setAbrir} video={video}/>
        </Grid>
        
    );
}
